/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type JoinGroupChannelMutationVariables = Exact<{
  contractId: string;
}>;


export type JoinGroupChannelMutation = { joinGroupChannel: { channelUrl: string } | null };


export const JoinGroupChannelDocument = /*#__PURE__*/ gql`
    mutation JoinGroupChannel($contractId: uuid!) {
  joinGroupChannel(contractId: $contractId) {
    channelUrl
  }
}
    `;
export type JoinGroupChannelMutationFn = Apollo.MutationFunction<JoinGroupChannelMutation, JoinGroupChannelMutationVariables>;

/**
 * __useJoinGroupChannelMutation__
 *
 * To run a mutation, you first call `useJoinGroupChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinGroupChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinGroupChannelMutation, { data, loading, error }] = useJoinGroupChannelMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useJoinGroupChannelMutation(baseOptions?: Apollo.MutationHookOptions<JoinGroupChannelMutation, JoinGroupChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinGroupChannelMutation, JoinGroupChannelMutationVariables>(JoinGroupChannelDocument, options);
      }
export type JoinGroupChannelMutationHookResult = ReturnType<typeof useJoinGroupChannelMutation>;
export type JoinGroupChannelMutationResult = Apollo.MutationResult<JoinGroupChannelMutation>;
export type JoinGroupChannelMutationOptions = Apollo.BaseMutationOptions<JoinGroupChannelMutation, JoinGroupChannelMutationVariables>;